import axios from 'axios';

// const apiUrl = 'https://house-of-theta-quiz.herokuapp.com/';

// const apiUrl = 'http://localhost:5000';

const apiUrl = 'https://house-project-2882.nw.r.appspot.com';
// const apiUrl = 'http://139.162.247.113:3071'

// require('dotenv').config();

export function closeNotification(context) {
    setTimeout(function () {
        context.setState({
            isShowing: false,
            formTextField: '',
            formOrderField: ''
        })
    }, 2000)
}

export function addQuestion(object) {
    return axios.post(`${apiUrl}/questions`, object);
}

export function getQuestion(questionId) {
    return axios.get(`${apiUrl}/questions/${questionId}`);
}

export function setAnswerCorrect(questionId, answerId) {
    return axios.patch(`${apiUrl}/questions/${questionId}/answers/${answerId}/correct`)
}

export function addAnswer(questionId, object) {
    return axios.post(`${apiUrl}/questions/${questionId}/answers`, object);
}

export function editQuestion(questionId, object) {
    return axios.patch(`${apiUrl}/questions/${questionId}`, {update: object});
}

export function editAnswer(questionId, answerId, object) {
    return axios.put(`${apiUrl}/questions/${questionId}/answers/${answerId}`, {answer: object});
}

export function deleteQuestion(questionId) {
    return axios.delete(`${apiUrl}/questions/${questionId}`);
}

export function deleteAnswer(questionId, answerId) {
    return axios.delete(`${apiUrl}/questions/${questionId}/answers/${answerId}`);
}


// WEBPACK FOOTER //
// ./src/services/QuestionServices.jsx